/**
 * Transactions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WebsiteCountries = 'AFGHANISTAN' | 'ALBANIA' | 'ALGERIA' | 'ANDORRA' | 'ANGOLA' | 'ANTIGUAAND BARBUD' | 'ARGENTINA' | 'ARMENIA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'THE BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BHUTAN' | 'BOLIVIA' | 'BOSNIA AND HERZEGOVINA' | 'BOTSWANA' | 'BRAZIL' | 'BRUNEI' | 'BULGARIA' | 'BURKINA FASO' | 'BURUNDI' | 'CABO VERDE' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CENTRAL AFRICAN REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'COLOMBIA' | 'COMOROS' | 'DEMOCRATIC' | 'REPUBLIC OF THE CONGO' | 'COSTA RICA' | '\'CÔTE`D\'IVOIRE\'' | 'CROATIA' | 'CUBA' | 'CYPRUS' | 'CZECH REPUBLIC' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN REPUBLIC' | 'EAST TIMOR (TIMOR-LESTE)' | 'ECUADOR' | 'EGYPT' | 'EL SALVADOR' | 'EQUATORIAL GUINEA' | 'ERITREA' | 'ESTONIA' | 'ESWATINI' | 'ETHIOPIA' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'GABON' | 'THE GAMBIA' | 'GEORGIA' | 'GERMANY' | 'GHANA' | 'GREECE' | 'GRENADA' | 'GUATEMALA' | 'GUINEA' | 'GUINEA BISSAU' | 'GUYANA' | 'HAITI' | 'HONDURAS' | 'HONG KONG; CHINA' | 'HUNGARY' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'NORTH KOREA' | 'SOUTH KOREA' | 'KOSOVO' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAOS' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYA' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL ISLANDS' | 'MAURITANIA' | 'MAURITIUS' | 'MEXICO' | 'FEDERATED STATES OF MICRONESIA' | 'MOLDOVA' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR (BURMA)' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NEW ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NORTH MACEDONIA' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PANAMA' | 'PAPUA NEW GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'POLAND' | 'PORTUGAL' | 'QATAR' | 'ROMANIA' | 'RUSSIA' | 'RUSSIAN FEDERATION' | 'RWANDA' | 'SAINT KITTS AND NEVIS' | 'SAINT LUCIA' | 'SAINT VINCENT AND THE GRENADINES' | 'SAMOA' | 'SAN MARINO' | 'SAO TOME AND PRINCIPE' | 'SAUDI ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA LEONE' | 'SINGAPORE' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON ISLANDS' | 'SOMALIA' | 'SOUTH AFRICA' | 'SPAIN' | 'SRI LANKA' | 'SUDAN' | 'SUDAN SOUTH' | 'SURINAME' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIA' | 'TAIWAN' | 'TAJIKISTAN' | 'TANZANIA' | 'THAILAND' | 'TOGO' | 'TONGA' | 'TRINIDAD AND TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED ARAB EMIRATES' | 'UNITED KINGDOM' | 'UNITED STATES' | 'UNITED STATES OF AMERICA' | 'URUGUAY' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN CITY' | 'VENEZUELA' | 'VIETNAM' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE';

export const WebsiteCountries = {
    AFGHANISTAN: 'AFGHANISTAN' as WebsiteCountries,
    ALBANIA: 'ALBANIA' as WebsiteCountries,
    ALGERIA: 'ALGERIA' as WebsiteCountries,
    ANDORRA: 'ANDORRA' as WebsiteCountries,
    ANGOLA: 'ANGOLA' as WebsiteCountries,
    ANTIGUAAND_BARBUD: 'ANTIGUAAND BARBUD' as WebsiteCountries,
    ARGENTINA: 'ARGENTINA' as WebsiteCountries,
    ARMENIA: 'ARMENIA' as WebsiteCountries,
    AUSTRALIA: 'AUSTRALIA' as WebsiteCountries,
    AUSTRIA: 'AUSTRIA' as WebsiteCountries,
    AZERBAIJAN: 'AZERBAIJAN' as WebsiteCountries,
    THE_BAHAMAS: 'THE BAHAMAS' as WebsiteCountries,
    BAHRAIN: 'BAHRAIN' as WebsiteCountries,
    BANGLADESH: 'BANGLADESH' as WebsiteCountries,
    BARBADOS: 'BARBADOS' as WebsiteCountries,
    BELARUS: 'BELARUS' as WebsiteCountries,
    BELGIUM: 'BELGIUM' as WebsiteCountries,
    BELIZE: 'BELIZE' as WebsiteCountries,
    BENIN: 'BENIN' as WebsiteCountries,
    BHUTAN: 'BHUTAN' as WebsiteCountries,
    BOLIVIA: 'BOLIVIA' as WebsiteCountries,
    BOSNIA_AND_HERZEGOVINA: 'BOSNIA AND HERZEGOVINA' as WebsiteCountries,
    BOTSWANA: 'BOTSWANA' as WebsiteCountries,
    BRAZIL: 'BRAZIL' as WebsiteCountries,
    BRUNEI: 'BRUNEI' as WebsiteCountries,
    BULGARIA: 'BULGARIA' as WebsiteCountries,
    BURKINA_FASO: 'BURKINA FASO' as WebsiteCountries,
    BURUNDI: 'BURUNDI' as WebsiteCountries,
    CABO_VERDE: 'CABO VERDE' as WebsiteCountries,
    CAMBODIA: 'CAMBODIA' as WebsiteCountries,
    CAMEROON: 'CAMEROON' as WebsiteCountries,
    CANADA: 'CANADA' as WebsiteCountries,
    CENTRAL_AFRICAN_REPUBLIC: 'CENTRAL AFRICAN REPUBLIC' as WebsiteCountries,
    CHAD: 'CHAD' as WebsiteCountries,
    CHILE: 'CHILE' as WebsiteCountries,
    CHINA: 'CHINA' as WebsiteCountries,
    COLOMBIA: 'COLOMBIA' as WebsiteCountries,
    COMOROS: 'COMOROS' as WebsiteCountries,
    DEMOCRATIC: 'DEMOCRATIC' as WebsiteCountries,
    REPUBLIC_OF_THE_CONGO: 'REPUBLIC OF THE CONGO' as WebsiteCountries,
    COSTA_RICA: 'COSTA RICA' as WebsiteCountries,
    CTEDIVOIRE: '\'CÔTE`D\'IVOIRE\'' as WebsiteCountries,
    CROATIA: 'CROATIA' as WebsiteCountries,
    CUBA: 'CUBA' as WebsiteCountries,
    CYPRUS: 'CYPRUS' as WebsiteCountries,
    CZECH_REPUBLIC: 'CZECH REPUBLIC' as WebsiteCountries,
    DENMARK: 'DENMARK' as WebsiteCountries,
    DJIBOUTI: 'DJIBOUTI' as WebsiteCountries,
    DOMINICA: 'DOMINICA' as WebsiteCountries,
    DOMINICAN_REPUBLIC: 'DOMINICAN REPUBLIC' as WebsiteCountries,
    EAST_TIMOR__TIMOR_LESTE: 'EAST TIMOR (TIMOR-LESTE)' as WebsiteCountries,
    ECUADOR: 'ECUADOR' as WebsiteCountries,
    EGYPT: 'EGYPT' as WebsiteCountries,
    EL_SALVADOR: 'EL SALVADOR' as WebsiteCountries,
    EQUATORIAL_GUINEA: 'EQUATORIAL GUINEA' as WebsiteCountries,
    ERITREA: 'ERITREA' as WebsiteCountries,
    ESTONIA: 'ESTONIA' as WebsiteCountries,
    ESWATINI: 'ESWATINI' as WebsiteCountries,
    ETHIOPIA: 'ETHIOPIA' as WebsiteCountries,
    FIJI: 'FIJI' as WebsiteCountries,
    FINLAND: 'FINLAND' as WebsiteCountries,
    FRANCE: 'FRANCE' as WebsiteCountries,
    GABON: 'GABON' as WebsiteCountries,
    THE_GAMBIA: 'THE GAMBIA' as WebsiteCountries,
    GEORGIA: 'GEORGIA' as WebsiteCountries,
    GERMANY: 'GERMANY' as WebsiteCountries,
    GHANA: 'GHANA' as WebsiteCountries,
    GREECE: 'GREECE' as WebsiteCountries,
    GRENADA: 'GRENADA' as WebsiteCountries,
    GUATEMALA: 'GUATEMALA' as WebsiteCountries,
    GUINEA: 'GUINEA' as WebsiteCountries,
    GUINEA_BISSAU: 'GUINEA BISSAU' as WebsiteCountries,
    GUYANA: 'GUYANA' as WebsiteCountries,
    HAITI: 'HAITI' as WebsiteCountries,
    HONDURAS: 'HONDURAS' as WebsiteCountries,
    HONG_KONG_CHINA: 'HONG KONG; CHINA' as WebsiteCountries,
    HUNGARY: 'HUNGARY' as WebsiteCountries,
    ICELAND: 'ICELAND' as WebsiteCountries,
    INDIA: 'INDIA' as WebsiteCountries,
    INDONESIA: 'INDONESIA' as WebsiteCountries,
    IRAN: 'IRAN' as WebsiteCountries,
    IRAQ: 'IRAQ' as WebsiteCountries,
    IRELAND: 'IRELAND' as WebsiteCountries,
    ISRAEL: 'ISRAEL' as WebsiteCountries,
    ITALY: 'ITALY' as WebsiteCountries,
    JAMAICA: 'JAMAICA' as WebsiteCountries,
    JAPAN: 'JAPAN' as WebsiteCountries,
    JORDAN: 'JORDAN' as WebsiteCountries,
    KAZAKHSTAN: 'KAZAKHSTAN' as WebsiteCountries,
    KENYA: 'KENYA' as WebsiteCountries,
    KIRIBATI: 'KIRIBATI' as WebsiteCountries,
    NORTH_KOREA: 'NORTH KOREA' as WebsiteCountries,
    SOUTH_KOREA: 'SOUTH KOREA' as WebsiteCountries,
    KOSOVO: 'KOSOVO' as WebsiteCountries,
    KUWAIT: 'KUWAIT' as WebsiteCountries,
    KYRGYZSTAN: 'KYRGYZSTAN' as WebsiteCountries,
    LAOS: 'LAOS' as WebsiteCountries,
    LATVIA: 'LATVIA' as WebsiteCountries,
    LEBANON: 'LEBANON' as WebsiteCountries,
    LESOTHO: 'LESOTHO' as WebsiteCountries,
    LIBERIA: 'LIBERIA' as WebsiteCountries,
    LIBYA: 'LIBYA' as WebsiteCountries,
    LIECHTENSTEIN: 'LIECHTENSTEIN' as WebsiteCountries,
    LITHUANIA: 'LITHUANIA' as WebsiteCountries,
    LUXEMBOURG: 'LUXEMBOURG' as WebsiteCountries,
    MADAGASCAR: 'MADAGASCAR' as WebsiteCountries,
    MALAWI: 'MALAWI' as WebsiteCountries,
    MALAYSIA: 'MALAYSIA' as WebsiteCountries,
    MALDIVES: 'MALDIVES' as WebsiteCountries,
    MALI: 'MALI' as WebsiteCountries,
    MALTA: 'MALTA' as WebsiteCountries,
    MARSHALL_ISLANDS: 'MARSHALL ISLANDS' as WebsiteCountries,
    MAURITANIA: 'MAURITANIA' as WebsiteCountries,
    MAURITIUS: 'MAURITIUS' as WebsiteCountries,
    MEXICO: 'MEXICO' as WebsiteCountries,
    FEDERATED_STATES_OF_MICRONESIA: 'FEDERATED STATES OF MICRONESIA' as WebsiteCountries,
    MOLDOVA: 'MOLDOVA' as WebsiteCountries,
    MONACO: 'MONACO' as WebsiteCountries,
    MONGOLIA: 'MONGOLIA' as WebsiteCountries,
    MONTENEGRO: 'MONTENEGRO' as WebsiteCountries,
    MOROCCO: 'MOROCCO' as WebsiteCountries,
    MOZAMBIQUE: 'MOZAMBIQUE' as WebsiteCountries,
    MYANMAR__BURMA: 'MYANMAR (BURMA)' as WebsiteCountries,
    NAMIBIA: 'NAMIBIA' as WebsiteCountries,
    NAURU: 'NAURU' as WebsiteCountries,
    NEPAL: 'NEPAL' as WebsiteCountries,
    NETHERLANDS: 'NETHERLANDS' as WebsiteCountries,
    NEW_ZEALAND: 'NEW ZEALAND' as WebsiteCountries,
    NICARAGUA: 'NICARAGUA' as WebsiteCountries,
    NIGER: 'NIGER' as WebsiteCountries,
    NIGERIA: 'NIGERIA' as WebsiteCountries,
    NORTH_MACEDONIA: 'NORTH MACEDONIA' as WebsiteCountries,
    NORWAY: 'NORWAY' as WebsiteCountries,
    OMAN: 'OMAN' as WebsiteCountries,
    PAKISTAN: 'PAKISTAN' as WebsiteCountries,
    PALAU: 'PALAU' as WebsiteCountries,
    PANAMA: 'PANAMA' as WebsiteCountries,
    PAPUA_NEW_GUINEA: 'PAPUA NEW GUINEA' as WebsiteCountries,
    PARAGUAY: 'PARAGUAY' as WebsiteCountries,
    PERU: 'PERU' as WebsiteCountries,
    PHILIPPINES: 'PHILIPPINES' as WebsiteCountries,
    POLAND: 'POLAND' as WebsiteCountries,
    PORTUGAL: 'PORTUGAL' as WebsiteCountries,
    QATAR: 'QATAR' as WebsiteCountries,
    ROMANIA: 'ROMANIA' as WebsiteCountries,
    RUSSIA: 'RUSSIA' as WebsiteCountries,
    RUSSIAN_FEDERATION: 'RUSSIAN FEDERATION' as WebsiteCountries,
    RWANDA: 'RWANDA' as WebsiteCountries,
    SAINT_KITTS_AND_NEVIS: 'SAINT KITTS AND NEVIS' as WebsiteCountries,
    SAINT_LUCIA: 'SAINT LUCIA' as WebsiteCountries,
    SAINT_VINCENT_AND_THE_GRENADINES: 'SAINT VINCENT AND THE GRENADINES' as WebsiteCountries,
    SAMOA: 'SAMOA' as WebsiteCountries,
    SAN_MARINO: 'SAN MARINO' as WebsiteCountries,
    SAO_TOME_AND_PRINCIPE: 'SAO TOME AND PRINCIPE' as WebsiteCountries,
    SAUDI_ARABIA: 'SAUDI ARABIA' as WebsiteCountries,
    SENEGAL: 'SENEGAL' as WebsiteCountries,
    SERBIA: 'SERBIA' as WebsiteCountries,
    SEYCHELLES: 'SEYCHELLES' as WebsiteCountries,
    SIERRA_LEONE: 'SIERRA LEONE' as WebsiteCountries,
    SINGAPORE: 'SINGAPORE' as WebsiteCountries,
    SLOVAKIA: 'SLOVAKIA' as WebsiteCountries,
    SLOVENIA: 'SLOVENIA' as WebsiteCountries,
    SOLOMON_ISLANDS: 'SOLOMON ISLANDS' as WebsiteCountries,
    SOMALIA: 'SOMALIA' as WebsiteCountries,
    SOUTH_AFRICA: 'SOUTH AFRICA' as WebsiteCountries,
    SPAIN: 'SPAIN' as WebsiteCountries,
    SRI_LANKA: 'SRI LANKA' as WebsiteCountries,
    SUDAN: 'SUDAN' as WebsiteCountries,
    SUDAN_SOUTH: 'SUDAN SOUTH' as WebsiteCountries,
    SURINAME: 'SURINAME' as WebsiteCountries,
    SWEDEN: 'SWEDEN' as WebsiteCountries,
    SWITZERLAND: 'SWITZERLAND' as WebsiteCountries,
    SYRIA: 'SYRIA' as WebsiteCountries,
    TAIWAN: 'TAIWAN' as WebsiteCountries,
    TAJIKISTAN: 'TAJIKISTAN' as WebsiteCountries,
    TANZANIA: 'TANZANIA' as WebsiteCountries,
    THAILAND: 'THAILAND' as WebsiteCountries,
    TOGO: 'TOGO' as WebsiteCountries,
    TONGA: 'TONGA' as WebsiteCountries,
    TRINIDAD_AND_TOBAGO: 'TRINIDAD AND TOBAGO' as WebsiteCountries,
    TUNISIA: 'TUNISIA' as WebsiteCountries,
    TURKEY: 'TURKEY' as WebsiteCountries,
    TURKMENISTAN: 'TURKMENISTAN' as WebsiteCountries,
    TUVALU: 'TUVALU' as WebsiteCountries,
    UGANDA: 'UGANDA' as WebsiteCountries,
    UKRAINE: 'UKRAINE' as WebsiteCountries,
    UNITED_ARAB_EMIRATES: 'UNITED ARAB EMIRATES' as WebsiteCountries,
    UNITED_KINGDOM: 'UNITED KINGDOM' as WebsiteCountries,
    UNITED_STATES: 'UNITED STATES' as WebsiteCountries,
    UNITED_STATES_OF_AMERICA: 'UNITED STATES OF AMERICA' as WebsiteCountries,
    URUGUAY: 'URUGUAY' as WebsiteCountries,
    UZBEKISTAN: 'UZBEKISTAN' as WebsiteCountries,
    VANUATU: 'VANUATU' as WebsiteCountries,
    VATICAN_CITY: 'VATICAN CITY' as WebsiteCountries,
    VENEZUELA: 'VENEZUELA' as WebsiteCountries,
    VIETNAM: 'VIETNAM' as WebsiteCountries,
    YEMEN: 'YEMEN' as WebsiteCountries,
    ZAMBIA: 'ZAMBIA' as WebsiteCountries,
    ZIMBABWE: 'ZIMBABWE' as WebsiteCountries
};

